export const environment = {
  production: true,
  buildId: '3179005578220871',
  configFile: 'config.json',
};
